// extracted by mini-css-extract-plugin
module.exports = {"title":"_3Bpde","text":"_3Aov1","section":"_3GmzD","column":"_2t4Xy"};